;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import get from "lodash/get"
import isCohortScheduleSpecificDates from "../../../../lib/cohort/isCohortScheduleSpecificDates"
import guessAndCastDateTimeToLocal from "../../../../lib/formatter/guessAndCastDateTimeToLocal"
import RecurringDaysSchedule from "./RecurringDaysSchedule"
import SessionDatesTable from "./SessionDatesTable"
import { Cohort, SessionDate, SessionInfo } from "../types"

const SECTION_HEADER_STYLING =
  "font-bebas min-[800px]:font-roboto font-bold text-[20px] mt-[30px] mb-[10px]"

type Props = {
  cohort: Cohort
  cohortId: number | null
  sessionInfo: SessionInfo
  nextSessions: SessionDate[]
  nextSessionsTotalCount: number
}

export default function ScheduleAndSessionDates({
  cohort,
  cohortId: _cohortId,
  sessionInfo,
  nextSessions,
  nextSessionsTotalCount,
}: Props) {
  const isSpecificDates = isCohortScheduleSpecificDates(cohort)
  const isDefinite = get(sessionInfo, "isDefinite", false) as boolean

  const firstSessionDateCastToLocalTime = guessAndCastDateTimeToLocal(
    get(sessionInfo, "upcomingSessionStartsAt", null),
  )
  const firstSessionDateFormatted = firstSessionDateCastToLocalTime.format("M/D/YY")
  const lastSessionDateCastToLocalTime = guessAndCastDateTimeToLocal(
    get(sessionInfo, "lastSessionStartsAt", null),
  )
  const lastSessionDateFormatted = lastSessionDateCastToLocalTime.format("M/D/YY")

  const page = 0
  const setPage = () => {}

  const renderSessionDatesHeader = () => {
    return (
      <div className={SECTION_HEADER_STYLING} key={"session-dates-header"}>
        {isDefinite ? "Session dates" : "Session dates are ongoing"}
      </div>
    )
  }

  const renderInfiniteDatesDisclaimer = () => {
    return (
      <div className="text-[18px] tracking-[1.26px] leading-[23px]">
        Sessions will continue indefinitely on a recurring basis.
      </div>
    )
  }

  const renderSessionDatesDescriptor = () => {
    if (!isDefinite) {
      return (
        <div>
          Purchasing a seat in this cohort reserves your ongoing attendance beginning{" "}
          <span className="font-medium">{firstSessionDateFormatted}</span>. To opt
          out of the cohort, message your group leader or support@getzestlife.com.
          The upcoming 5 sessions are listed below:
        </div>
      )
    }

    if (nextSessionsTotalCount === 1) {
      return (
        <div>
          Purchasing a seat in this cohort reserves your attendance on{" "}
          <span className="font-medium">{firstSessionDateFormatted}</span> at the
          following time:
        </div>
      )
    }

    return (
      <div>
        Purchasing a seat in this cohort reserves your attendance from{" "}
        <span className="font-medium">{firstSessionDateFormatted}</span> to{" "}
        <span className="font-medium">{lastSessionDateFormatted}</span> on the
        following dates and times:
      </div>
    )
  }

  return (
    <div className="min-[600px]:px-[20px] mt-[10px] text-[17px] min-[800px]:text-[18px]">
      <div className={SECTION_HEADER_STYLING}>Schedule</div>
      {isSpecificDates
        ? null
        : [
            <RecurringDaysSchedule cohort={cohort} key="rds" />,
            renderSessionDatesHeader(),
          ]}
      {renderSessionDatesDescriptor()}
      <SessionDatesTable
        page={page}
        setPage={setPage}
        isDefinite={isDefinite}
        nextSessions={nextSessions}
        nextSessionsTotalCount={nextSessionsTotalCount}
      />
      {isDefinite ? null : renderInfiniteDatesDisclaimer()}
    </div>
  )
}
